import { createReducer } from 'redux-starter-kit';
import { selectRequest } from '../../../domain/requests/RequestReducer';
import { loadCurrencyReports, loadTaxReportRegions } from './financialUiActions';


/**
 * Selectors
 */
export const selectLoadCurrencyReportsRequest = (state) => {
  const requestId = state.via.ui.financial.loadCurrencyReportsRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};
export const selectLoadTaxReportRegionsRequest = (state) => {
  const requestId = state.via.ui.financial.loadTaxReportRegionsRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};


const initialFinancialState = {
  loadCurrencyReportsRequestId: null,
  loadTaxReportRegionsRequestId: null,
};

/**
 * A reducer for application configuration requests.
 */
const financialUiReducer = createReducer(initialFinancialState, {

  [loadCurrencyReports]: (state, action) => ({
    ...state,
    loadCurrencyReportsRequestId: action.payload.requestId,
  }),

  [loadTaxReportRegions]: (state, action) => ({
    ...state,
    loadTaxReportRegionsRequestId: action.payload.requestId,
  }),

});

export default financialUiReducer;
